export const API = process.env.REACT_APP_API;
export const GRAPHQL = process.env.REACT_APP_GRAPHQL;
export const SCORO_URL = process.env.REACT_APP_SCORO_URL;
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;
export const STATIC_URL = process.env.REACT_APP_STATIC_URL;
export const BASE = process.env.REACT_APP_BASE;
export const HOST = process.env.REACT_APP_HOST;
export const SENTRY_DNS = process.env.REACT_APP_SENTRY_DNS;
export const DATE_FORMAT = 'yyyy-MM-dd';

export { default as locale } from 'date-fns/locale/lt';
